import { ReactNode } from 'react'
import { ALERT_ICON, AlertType } from './Alert'

const BACKGROUND: Record<AlertType, string> = {
	success: 'bg-algae-500',
	info: 'bg-algae-050',
	error: 'bg-error-400',
	warning: 'bg-warning-500',
}

// Dark text is enforced on the banner and every descendant, so parent colour and legacy `text-white` children can't leak in.
const TEXT = 'text-charcoal-900 [&_*]:text-charcoal-900 [&_.text-link:hover]:text-charcoal-900'

type InlineAlertProps = {
	type: AlertType
	className?: string
	'data-testid'?: string
	children: ReactNode
}

function InlineAlert({ type, className = 'mt-6', children, ...rest }: InlineAlertProps) {
	return (
		<div
			className={`${BACKGROUND[type]} ${TEXT} flex items-start rounded p-4 text-sm ${className}`}
			role={type === 'error' ? 'alert' : 'status'}
			data-testid={rest['data-testid']}
		>
			<span className={`${ALERT_ICON[type]} pr-4 pt-0.5`} aria-hidden='true' />
			<div className='min-w-0'>{children}</div>
		</div>
	)
}

export default InlineAlert
